import { can } from '../core/access';
import { setPageTitle } from '../users/users-shared';
import { t } from '../ui/lang';
import { esc } from '../ui/modal';
import { fetchClickerApps, clickerAppLabel } from '../clicker/clicker-apps-shared';
import { mountOpsStatusChart } from './ops-status-chart';
// ── Charts page ─────────────────────────────────────────────────────────────────
//
// Admin+ reporting over the operations registry. One filter row drives every chart on
// the page; each chart lives in its own file and exposes a loader taking the filters.
/** The default range: the last day, broken down by hour. */
const DEFAULT_HOURS = 24;
const two = (n) => String(n).padStart(2, '0');
/** A `datetime-local` value, minutes zeroed: the filter works in whole hours. */
const hourInput = (d) => `${d.getFullYear()}-${two(d.getMonth() + 1)}-${two(d.getDate())}T${two(d.getHours())}:00`;
export function renderCharts() {
    setPageTitle(t('charts.title'));
    const content = document.getElementById('content');
    // Only a superadmin reads more than one team (same gate as the operations registry).
    const showTeam = can('ops.team');
    // The last DEFAULT_HOURS whole hours, up to the end of the current one.
    const end = new Date();
    end.setMinutes(0, 0, 0);
    end.setHours(end.getHours() + 1);
    const start = new Date(end);
    start.setHours(start.getHours() - DEFAULT_HOURS);
    content.innerHTML = `
        <div class="settings-panel settings-panel--wide charts-page">
            <div class="clicker-ops-toolbar">
                ${showTeam ? `<label class="ops-filter">${t('common.team')}
                    <select class="settings-input ch-team"><option value="">${t('common.all')}</option></select>
                </label>` : ''}
                <label class="ops-filter">${t('common.farm')}
                    <select class="settings-input ch-farm"><option value="">${t('common.all')}</option></select>
                </label>
                <label class="ops-filter">${t('clickertab.app')}
                    <select class="settings-input ch-app"><option value="">${t('clickertab.all')}</option></select>
                </label>
                <label class="ops-filter">${t('clickertab.type')}
                    <select class="settings-input ch-type">
                        <option value="">${t('clickertab.all')}</option>
                        <option value="payout">${t('clickertab.task_payout_all')}</option>
                        <option value="external_payout">${t('clickertab.task_external_payout')}</option>
                        <option value="merchant_payout">${t('clickertab.task_merchant_payout')}</option>
                        <option value="deposit">${t('clickertab.task_deposit')}</option>
                    </select>
                </label>
                <label class="ops-filter">${t('clickertab.from')}
                    <input type="datetime-local" step="3600" class="settings-input ch-from" value="${hourInput(start)}" />
                </label>
                <label class="ops-filter">${t('clickertab.to')}
                    <input type="datetime-local" step="3600" class="settings-input ch-to" value="${hourInput(end)}" />
                </label>
                <label class="ops-filter">${t('charts.bucket')}
                    <select class="settings-input ch-bucket">
                        <option value="">${t('charts.bucket_auto')}</option>
                        <option value="hour" selected>${t('charts.bucket_hour')}</option>
                        <option value="day">${t('charts.bucket_day')}</option>
                    </select>
                </label>
            </div>
            <div class="charts-grid"><div class="ch-ops-status"></div></div>
        </div>
    `;
    const $ = (sel) => content.querySelector(sel);
    const teamEl = content.querySelector('.ch-team');
    const farmEl = $('.ch-farm');
    const appEl = $('.ch-app');
    const typeEl = $('.ch-type');
    const fromEl = $('.ch-from');
    const toEl = $('.ch-to');
    const bucketEl = $('.ch-bucket');
    const loadOpsStatus = mountOpsStatusChart($('.ch-ops-status'));
    const filters = () => ({
        from: fromEl.value, to: toEl.value, farmId: farmEl.value, teamId: teamEl?.value ?? '', type: typeEl.value, app: appEl.value,
        bucket: bucketEl.value,
    });
    const reload = () => { loadOpsStatus(filters()); };
    let farms = [];
    // The farm list follows the chosen team, so it never offers a farm the chart would drop.
    const fillFarms = () => {
        const team = teamEl?.value ?? '';
        const selected = farmEl.value;
        const list = farms.filter((f) => !team || String(f.team_id ?? '') === team)
            .sort((a, b) => a.name.localeCompare(b.name));
        farmEl.innerHTML = `<option value="">${t('common.all')}</option>`
            + list.map((f) => `<option value="${f.id}">${esc(f.name)}</option>`).join('');
        if (list.some((f) => String(f.id) === selected))
            farmEl.value = selected;
    };
    void fetch('/api/farms').then(async (r) => {
        if (!r.ok)
            return;
        farms = await r.json();
        fillFarms();
    }).catch(() => { });
    if (teamEl) {
        void fetch('/api/teams').then(async (r) => {
            if (!r.ok)
                return;
            const teams = (await r.json()).sort((a, b) => a.name.localeCompare(b.name));
            teamEl.innerHTML = `<option value="">${t('common.all')}</option>`
                + teams.map((tm) => `<option value="${tm.id}">${esc(tm.name)}</option>`).join('');
        }).catch(() => { });
        teamEl.addEventListener('change', () => { fillFarms(); reload(); });
    }
    farmEl.addEventListener('change', reload);
    typeEl.addEventListener('change', reload);
    appEl.addEventListener('change', reload);
    void fetchClickerApps().then((apps) => {
        appEl.innerHTML = `<option value="">${t('clickertab.all')}</option>`
            + apps.map((a) => `<option value="${esc(a.name)}">${esc(clickerAppLabel(a))}</option>`).join('');
    }).catch(() => { });
    bucketEl.addEventListener('change', reload);
    // Keep the range well-formed: moving one end past the other drags the other along.
    fromEl.addEventListener('change', () => { if (toEl.value && fromEl.value > toEl.value)
        toEl.value = fromEl.value; reload(); });
    toEl.addEventListener('change', () => { if (fromEl.value && toEl.value < fromEl.value)
        fromEl.value = toEl.value; reload(); });
    reload();
}
